// extracted by mini-css-extract-plugin
export default {"buttonClose":"ModalDeleteExam_buttonClose__CG8Vx","iconCloseModal":"ModalDeleteExam_iconCloseModal__8k4R2"};